import React from 'react'
import { createContainer } from '@dbk-legacy/muster/react'
import Modal from '@dbk/ui-modal'
import Text from '@dbk/ui-text'
import Button from '@dbk/ui-buttons'
import { Large } from '@dbk/ui-text';
import {
  SuccessIcon
} from '../../../components/common/icons'
class AcceptSignSuccessModal extends React.PureComponent {
  constructor() {
    super()
  }

  onDoneButtonClicked = () => {
    this.props.changePage('/portfolios', true);
    this.props.changePage('/docsign/document-list');
  }

  render() {
    const {
      i18n: { messages }, onDone
    } = this.props;
    return (
      <Modal
        isActive
        hideCloseButton
        disableOutsideClick
        header={messages['app.docsign.acceptsign.accept.confirmation']}
        content={
          <div className="acceptsign-modal">
            <div className="modal-content">
              <div className="acceptsign-status-message">
                <SuccessIcon width={25} height={25} />
                <Large secondary>
                  {messages['app.docsign.acceptsign.success']}
                </Large>
              </div>
              <div>
                <Text secondary>
                  {this.props.acceptsign.documentName + " " + messages['app.docsign.acceptsign.is.accepted']}
                </Text>
              </div>
            </div>
            <div className="submit-btn">
              <Button
                onPress={this.onDoneButtonClicked} >
                {messages['app.calendar.doneBtn']}
              </Button>
            </div>
          </div>
        }
      />
    )
  }
}
export default createContainer({
  $queries: {
    i18n: { messages: true },
    changePage: { $call: 'ui.history.push' },
    acceptsign: {
      documentName: true,
    }
  },
})(AcceptSignSuccessModal);
